module.exports = __webpack_public_path__ + "src/assets/no-data-found.png";